var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _vm.isLoading
        ? _c(
            "v-layout",
            {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                "z-index": "1000",
                background: "rgba(255, 255, 255, .95)"
              },
              attrs: { "align-center": "", "justify-center": "" }
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _c("div", { staticClass: "lds-roller" }, [
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Patientez SVP ...")])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { wrap: "", "mx-2": "" } },
        [
          _c(
            "v-flex",
            {
              staticClass: "form-section",
              attrs: { xs12: "", md6: "", "pl-1": "", "pr-5": "" }
            },
            [
              _c(
                "v-flex",
                [
                  _c("v-layout", { staticClass: "title--text-custom" }, [
                    _c("div", { staticClass: "primary--text" }, [_vm._v("1")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
                  ]),
                  _vm._v(" "),
                  _c("h1", { staticClass: "primary--text" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(_vm.lblSetting.apartmentForm.firstSectionTitle)
                      )
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.showSelectApartment
                ? [
                    !_vm.createNewApartment
                      ? _c(
                          "base-control-label-vertical",
                          {
                            attrs: {
                              label:
                                _vm.lblSetting.serviceBookModal.selectApartment
                            }
                          },
                          [
                            _c("base-autocomplete", {
                              attrs: {
                                items: _vm.coApartments,
                                "on-fetch-remote": _vm.handleGetApartments,
                                multiple: false,
                                "return-object": true,
                                clearable: true,
                                rules: [],
                                "item-value": "value"
                              },
                              on: { change: _vm.handleChangeApartment },
                              model: {
                                value: _vm.apartment,
                                callback: function($$v) {
                                  _vm.apartment = $$v
                                },
                                expression: "apartment"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.apartment
                      ? _c("v-switch", {
                          staticClass: "mt-0 ml-2",
                          attrs: {
                            color: "primary",
                            label: _vm.$t(
                              _vm.lblSetting.serviceBookModal.createNewApartment
                            )
                          },
                          model: {
                            value: _vm.createNewApartment,
                            callback: function($$v) {
                              _vm.createNewApartment = $$v
                            },
                            expression: "createNewApartment"
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.apartment
                ? _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        required: "",
                        label: _vm.lblSetting.serviceBookModal.apartmentType
                      }
                    },
                    [
                      _c("base-autocomplete", {
                        attrs: {
                          items: _vm.coApartmentTypes,
                          multiple: false,
                          "return-object": true,
                          rules: _vm.dtRules.apartmentType,
                          "item-value": "value"
                        },
                        on: { change: _vm.handleChangeApartmentType },
                        model: {
                          value: _vm.apartmentType,
                          callback: function($$v) {
                            _vm.apartmentType = $$v
                          },
                          expression: "apartmentType"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "base-control-label-vertical",
                {
                  attrs: {
                    required: "",
                    label: _vm.lblSetting.serviceBookModal.apartmentName
                  }
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      disabled:
                        _vm.apartment !== null && _vm.apartment !== undefined,
                      counter: 120,
                      maxlength: 120,
                      rules: _vm.dtRules.apartmentName,
                      solo: "",
                      label: "Ex: APT-2"
                    },
                    model: {
                      value: _vm.name,
                      callback: function($$v) {
                        _vm.name = $$v
                      },
                      expression: "name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.apartment
                ? _c(
                    "base-control-label-vertical",
                    {
                      attrs: { label: _vm.lblSetting.serviceBookModal.location }
                    },
                    [
                      _c("v-textarea", {
                        attrs: {
                          disabled:
                            _vm.apartment !== null &&
                            _vm.apartment !== undefined,
                          counter: 120,
                          maxlength: 120,
                          rules: [],
                          solo: ""
                        },
                        model: {
                          value: _vm.blockNameRef,
                          callback: function($$v) {
                            _vm.blockNameRef = $$v
                          },
                          expression: "blockNameRef"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.apartmentType && !_vm.apartment
                ? [
                    !_vm.createNewAddress
                      ? _c(
                          "base-control-label-vertical",
                          {
                            attrs: {
                              required: "",
                              label:
                                _vm.lblSetting.serviceBookModal.selectAddress
                            }
                          },
                          [
                            _c("base-autocomplete", {
                              attrs: {
                                items: _vm.coBlocks,
                                "on-fetch-remote": _vm.handleGetBlocks,
                                multiple: false,
                                "return-object": true,
                                clearable: true,
                                rules: _vm.dtRules.block,
                                "item-value": "value"
                              },
                              on: { change: _vm.handleChangeBlock },
                              model: {
                                value: _vm.block,
                                callback: function($$v) {
                                  _vm.block = $$v
                                },
                                expression: "block"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showCreateNewAddress && !_vm.block
                      ? _c("v-switch", {
                          staticClass: "mt-0 ml-2",
                          attrs: {
                            color: "primary",
                            label: _vm.$t(
                              _vm.lblSetting.serviceBookModal.createNewAddress
                            )
                          },
                          model: {
                            value: _vm.createNewAddress,
                            callback: function($$v) {
                              _vm.createNewAddress = $$v
                            },
                            expression: "createNewAddress"
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.createNewAddress
                ? _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        required: "",
                        label: _vm.lblSetting.blockAddressForm
                      }
                    },
                    [
                      _c("base-address-fields", {
                        attrs: { required: true },
                        model: {
                          value: _vm.address,
                          callback: function($$v) {
                            _vm.address = $$v
                          },
                          expression: "address"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "form-section",
              attrs: { xs12: "", md6: "", "pl-3": "", "pr-5": "" }
            },
            [
              _c(
                "v-flex",
                [
                  _c("v-layout", { staticClass: "title--text-custom" }, [
                    _c("div", { staticClass: "primary--text" }, [_vm._v("2")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
                  ]),
                  _vm._v(" "),
                  _c("h1", { staticClass: "primary--text " }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(_vm.lblSetting.apartmentForm.secondSectionTitle)
                      )
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasFloor
                ? [
                    _c(
                      "base-control-label-vertical",
                      { attrs: { label: _vm.lblSetting.apartmentForm.floor } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            disabled:
                              _vm.apartment !== null &&
                              _vm.apartment !== undefined,
                            counter: 5,
                            maxlength: 5,
                            rules: [],
                            solo: ""
                          },
                          model: {
                            value: _vm.floor,
                            callback: function($$v) {
                              _vm.floor = $$v
                            },
                            expression: "floor"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "base-control-label-vertical",
                { attrs: { label: _vm.lblSetting.apartmentForm.surface } },
                [
                  _c("v-text-field", {
                    attrs: {
                      disabled:
                        _vm.apartment !== null && _vm.apartment !== undefined,
                      counter: 5,
                      maxlength: 5,
                      rules: [],
                      solo: ""
                    },
                    model: {
                      value: _vm.surface,
                      callback: function($$v) {
                        _vm.surface = $$v
                      },
                      expression: "surface"
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42609652", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42609652","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/service-book/components/service-book-modal/template.html
// module id = null
// module chunks = 